// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useRef} from 'react';
import cn from 'classnames';
import zutil from 'zutil';
import {use_screen} from '../../lib/screen_util';
import styles from './colored_text.module.less';

export type t_colors = 'blue' | 'pink' | 'yellow';

interface i_colored_letter {
    char: string;
    color: t_colors;
}
const Letter = (props: i_colored_letter)=>{
    const {char, color} = props;
    const cls = cn(styles.letter, styles[color]);
    return <span className={cls}>{char}</span>;
};

interface i_colored_text {
    text: string;
    color: t_colors;
    highlight_width?: number;
}
export const Colored_text = (props: i_colored_text)=>{
    const {text, color, highlight_width = 2} = props;
    const text_ref = useRef<HTMLDivElement>();
    const text_el = text_ref.current;
    const {height, is_touch} = use_screen();
    useEffect(()=>{
        if (!text_el || is_touch)
            return;
        const letters = Array.from(text_el.children);
        const handle_mouse_over = ev=>{
            const index = letters.indexOf(ev.target);
            letters.forEach((letter, i)=>{
                if (i>=index-highlight_width && i<=index+highlight_width)
                    letter.classList.add(styles.active);
                else
                    letter.classList.remove(styles.active);
            });
        };
        const handle_mouse_leave = ev=>{
            if (ev.target != text_el)
                return;
            letters.forEach(letter=>{
                letter.classList.remove(styles.active);
            });
        };
        text_el.addEventListener('mouseover', handle_mouse_over);
        text_el.addEventListener('mouseleave', handle_mouse_leave);
        return ()=>{
            text_el.removeEventListener('mouseover', handle_mouse_over);
            text_el.removeEventListener('mouseleave', handle_mouse_leave);
        };
    }, [text_el, is_touch]);
    useEffect(()=>{
        if (!text_el || !is_touch)
            return;
        const handle_scroll = ()=>{
            const b = text_el.getBoundingClientRect();
            const pos = b.top / height;
            const centered = zutil.range(pos, 0.2, 0.4);
            if (centered)
                text_el.classList.add(styles.active);
            else
                text_el.classList.remove(styles.active);
        };
        handle_scroll();
        window.addEventListener('scroll', handle_scroll, {passive: true});
        return ()=>{
            window.removeEventListener('scroll', handle_scroll);
        };
    }, [text_el, height, is_touch]);
    const cls = cn(styles.colored_text, is_touch && styles.touch);
    return <div className={cls} ref={text_ref}>
      {text.split('').map((l, i)=>{
          return <Letter key={i} char={l} color={color}/>;
      })}
    </div>;
};
